// extracted by mini-css-extract-plugin
export var callCard = "_qt-0";
export var callMessageButton = "_qt-1";
export var helpIcon = "_qt-3";
export var helpIconContainer = "_qt-4";
export var verticalDivider = "_qt-2";